"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyYamlValues = exports.getEmptyFormViewHostsValues = exports.getEmptyNetworkWideConfigurations = exports.getEmptyYamlHost = exports.getEmptyIpConfig = exports.getEmptyFormViewHost = exports.getEmptyHostIps = void 0;
const getEmptyHostIps = () => {
    return {
        ipv4: '',
        ipv6: '',
    };
};
exports.getEmptyHostIps = getEmptyHostIps;
const getEmptyFormViewHost = () => {
    return {
        macAddress: '',
        ips: (0, exports.getEmptyHostIps)(),
        useBond: false,
        bondType: 'active-backup',
        bondPrimaryInterface: '',
        bondSecondaryInterface: '',
    };
};
exports.getEmptyFormViewHost = getEmptyFormViewHost;
const getEmptyIpConfig = () => {
    return {
        machineNetwork: {
            ip: '',
            prefixLength: '',
        },
        gateway: '',
    };
};
exports.getEmptyIpConfig = getEmptyIpConfig;
const getEmptyYamlHost = () => {
    return {
        networkYaml: '',
        macInterfaceMap: [{ macAddress: '', logicalNicName: '' }],
    };
};
exports.getEmptyYamlHost = getEmptyYamlHost;
const getEmptyNetworkWideConfigurations = () => {
    return {
        ipConfigs: {
            ipv4: (0, exports.getEmptyIpConfig)(),
            ipv6: (0, exports.getEmptyIpConfig)(),
        },
        protocolType: 'ipv4',
        useVlan: false,
        vlanId: '',
        dns: '',
    };
};
exports.getEmptyNetworkWideConfigurations = getEmptyNetworkWideConfigurations;
const getEmptyFormViewHostsValues = () => {
    return { hosts: [(0, exports.getEmptyFormViewHost)()] };
};
exports.getEmptyFormViewHostsValues = getEmptyFormViewHostsValues;
const getEmptyYamlValues = () => {
    return { hosts: [(0, exports.getEmptyYamlHost)()] };
};
exports.getEmptyYamlValues = getEmptyYamlValues;
//# sourceMappingURL=emptyData.js.map